export function getSessionCache(key) {
  try {
    return sessionStorage.getItem(key)
  } catch (e) {
    console.warn("[session cache] Failed to read key:", key, e)
    return null
  }
}

export function setSessionCache(key, value) {
  try {
    sessionStorage.setItem(key, value)
  } catch (e) {
    const isQuotaError = e instanceof DOMException && e.name === "QuotaExceededError"
    console.warn(
      isQuotaError
        ? "[session cache] Quota exceeded — skipping cache for key:"
        : "[session cache] Failed to write key:",
      key,
      e
    )
  }
}

export function formatMoney(cents, format = "${{amount_no_decimals}}") {
    if (typeof cents === 'string') {
        cents = cents.replace('.', '');
    }

    const defaultOption = (opt, def) => (typeof opt === 'undefined' ? def : opt);

    const formatWithDelimiters = (number, precision = 2, thousands = '', decimal = '') => {
        if (isNaN(number) || number === null) {
            return 0;
        }
        number = (number / 100).toFixed(precision);

        const [dollars, cents] = number.split('.');
        const formattedDollars = dollars.replace(/(\d)(?=(\d{3})+$)/g, '$1' + thousands);
        const formattedCents = cents ? decimal + cents : '';

        return formattedDollars + formattedCents;
    };

    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const match = format.match(placeholderRegex);

    if (!match) {
        return format;
    }

    const placeholder = match[1];
    let value;


    value = formatWithDelimiters(cents, 0);

    // switch (placeholder) {
    //     case 'amount':
    //         value = formatWithDelimiters(cents);
    //         break;
    //     case 'amount_no_decimals':
    //         value = formatWithDelimiters(cents, 0);
    //         break;
    //     case 'amount_with_comma_separator':
    //         value = formatWithDelimiters(cents, 2, '.', ',');
    //         break;
    //     case 'amount_no_decimals_with_comma_separator':
    //         value = formatWithDelimiters(cents, 0, '.', ',');
    //         break;
    //     default:
    //         value = '';
    // }

    return format.replace(placeholderRegex, value);
}